export default "__VITE_ASSET__CKK8542O__"